import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_2 = { class: "d-flex align-items-stretch ms-1 ms-lg-3" }
const _hoisted_3 = { class: "d-flex align-items-center ms-1 ms-lg-3" }
const _hoisted_4 = { class: "rounded bg-light fs-8 px-3 py-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "media/flags/thailand.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Thai ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "media/flags/united-states.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" English ")
const _hoisted_9 = {
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "cursor-pointer symbol symbol-circle symbol-30px symbol-md-40px",
  "data-kt-menu-target": "#kt-user-menu",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Pic",
    src: "media/avatars/150-1.jpg"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTSearch = _resolveComponent("KTSearch")!
  const _component_btn = _resolveComponent("btn")!
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!
  const _component_MenuComponent = _resolveComponent("MenuComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_KTSearch)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, [
        (_ctx.currentLang == 'th')
          ? (_openBlock(), _createBlock(_component_btn, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLang('en'), (_ctx.currentLang = 'en'))),
              class: _normalizeClass([{ active: _ctx.currentLanguage('en') }, "menu-link d-flex px-5"]),
              style: {"cursor":"pointer"}
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_ctx.currentLang == 'en')
          ? (_openBlock(), _createBlock(_component_btn, {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLang('th'), (_ctx.currentLang = 'th'))),
              class: _normalizeClass([{ active: _ctx.currentLanguage('th') }, "menu-link d-flex px-5"]),
              style: {"cursor":"pointer"}
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_MenuComponent, { "menu-selector": "#kt-user-menu" }, {
        toggle: _withCtx(() => [
          _hoisted_10
        ]),
        content: _withCtx(() => [
          _createVNode(_component_KTUserMenu)
        ]),
        _: 1
      })
    ])
  ]))
}